import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[trpLazyCardContent]',
    standalone: true,
})
export class LazyCardContentDirective {
    constructor(public templateRef: TemplateRef<unknown>) {}
}
